// extracted by mini-css-extract-plugin
export default {"errorText":"_1hs1N"};